import React, { useContext, createContext, useState, ReactNode } from "react";
import ReactDOM from "react-dom";

interface AliveScopeContextType {
  getPortalElement: any;
}

const AliveScopeContext = createContext<AliveScopeContextType>(null!);

interface ProviderProps {
  children: ReactNode;
}

type Nodes = {
  [key: string] : { element: Element,
                      children: ReactNode
    }
}

export const AliveScope: React.FC<ProviderProps> = ({ children }: ProviderProps) => {
  const [nodes, setNodes] = useState<Nodes>({});

  const getPortalElement = (id: keyof(Nodes), children: any) => {
    if (!nodes[id]) {
      const element = document.createElement("div");
      setNodes((prevNodes) => ({
        ...prevNodes,
        [id]: { children, element }
      }));
      return element;
    }
    return nodes[id].element;
  };

  return (
    <AliveScopeContext.Provider
      value={{
        getPortalElement
      }}
    >
      {children}
      {Object.entries(nodes).map(([id, { children, element }]) => (
        <React.Fragment key={id}>
          {ReactDOM.createPortal(children, element)}
        </React.Fragment>
      ))}
    </AliveScopeContext.Provider>
  );
};

export const useAliveScope = () => useContext(AliveScopeContext);
